<template>
  <div>
    <h1 class="entry-title">Search</h1>
    <div class="row">
      <h2 class="h6">Add Search parameters:</h2>
    </div>
    <div class="row">
      <div class="col-12 col-sm-4 col-lg-3 px-1 py-3  d-flex flex-column row-scroll">

        <template v-for="visible in sections">

          <template v-if="groupedFields[visible].length === 1">
            <div class="list-group list-group-flush">

              <a class="list-group-item list-group-item-action" :class="{ active: currentField == groupedFields[visible][0].label }" href="#" @click="currentField = groupedFields[visible][0].label">{{ groupedFields[visible][0].name }}</a>
            </div>

          </template>

          <template v-else>
            <div class="accordion accordion-flush">
              <div class="accordion-item">

                <a class="accordion-button p-2 collapsed" data-bs-toggle="collapse" :href="'#left_' + visible" role="button" aria-expanded="false" :aria-controls="'left_' + visible">
                  {{ glabels[visible] }}</a>

                <div :id="'left_' + visible" class="collapse list-group list-group-flush">
                  <template v-for="field of groupedFields[visible]">
                    <button class="list-group-item list-group-item-action" :class="{ 'active': currentField == field.label }" @click="currentField = field.label"> {{ field.name }}</button>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
      <div class="col-12 col-sm-8 col-lg-9 d-flex flex-column row-scroll">

        <template v-if="currentFieldObj">

          <FieldQuery :key="currentField" v-model="query[currentField]" :field="currentFieldObj"></FieldQuery>


        </template>

      </div>

    </div>
    <div class="row my-2">
      <h2 class="h6">Your Search:</h2>

      <div>
        <template v-for="values, key, index in queryObj">
          <div class="row mb-2">

            <div class="col-10">

              <template v-if="index > 0">
                <br />
                <span>&nbsp;AND&nbsp;</span>
              </template>
              <span>{{ lookupField(key)?.name }}</span>
              <span v-if="true">{{ printValues(key, values) }}</span>
              <span v-else-if="values.length == 1">
                = {{ values[0] }}
              </span>
              <span v-else>
                = {{ values.join('&nbsp;OR&nbsp;') }}
              </span>

            </div>
            <div class="col-2">
              <button class="btn btn-inverse-black" @click="query[key] = []" :aria-label="'Remove filter for ' + lookupField(key)?.name">Remove</button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- <div class="row">
      {{ queryObj }}
    </div> -->

    <div class="row">

      <div>{{ resultsCount.length }} results match your search</div>

      <div class="btn-group mb-3">
        <a :href="resultsURL" class="btn btn-inverse-black mx-1">Show results</a>
        <button @click="copySearchLink()" class="btn btn-inverse-black mx-1">Copy search link</button>
        <button @click="currentField = null; query = {}" class="btn btn-inverse-black mx-1">Clear all filters</button>
        <button @click="showColumnsModal = true" class="btn btn-inverse-black mx-1">Show additional columns</button>
      </div>

    </div>
    <ColumnsModal :fields="fieldsForDict" :query="queryObj" v-model="showColumnsModal" v-model:choices="userFields"></ColumnsModal>
  </div>
</template>

<script>
import FieldQuery from "../components/FieldQuery.vue";
import ColumnsModal from "../components/ColumnsModal.vue";
import { stringToSlug, simpleGroupBy } from "../lib/util.js";
import { visible_sections } from "../lib/project";

import { shallowReactive } from "vue";
export default {
  props: ['data', 'dict'],

  components: {
    FieldQuery,
    ColumnsModal,
  },

  data() {
    return {
      currentField: null,
      sections: [
        "state",
        ...visible_sections,
      ],
      query: {},
      showColumnsModal: false,
      userFields: [],
    };
  },

  mounted() {

    let params = new URLSearchParams(document.location.search);

    try {
      let encoded = params.get("query");
      let b64 = decodeURIComponent(encoded);

      if (b64) {
        let json = atob(b64);
        let query = JSON.parse(json);

        if (query) {
          console.info(`loaded query from URL`);
          Object.assign(this.query, query);
        }
      }
    } catch {
      Object.assign(this.query, {});
    }

    try {
      let encoded = params.get("columns");
      let b64 = decodeURIComponent(encoded);

      if (b64) {
        let json = atob(b64);
        let columns = JSON.parse(json);

        if (columns) {
          console.info(`loaded columns from URL`);
          this.userFields = [...columns];
        }
      }
    } catch {
      this.userFields = [];
    }


  },

  methods: {
    lookupField(key) {
      return this.fieldsForDict.find(field => field.label === key);
    },
    printValues(key, values) {
      let field = this.lookupField(key);

      if (!field) {
        return '';
      }

      let hasOptions = Object.keys(field.coding).length > 0;

      if (hasOptions) {
        return ' = ' + values.map(v => field.coding[v]).join(' OR ');
      } else {
        if (field.type == 'varchar') {
          return ' includes "' + values.join(' OR ') + '"';
        } else {
          return ' = ' + values.join(' OR ');
        }
      }



    },
    copySearchLink() {
      navigator.clipboard.writeText(this.searchURL);
    },
  },

  computed: {
    currentFieldObj() {
      return this.fieldsForDict.find(field => field.label === this.currentField)
    },

    /** map backend data into useful structure for frontend */
    fieldsForDict() {
      return this.dict.dict.map((def) => {

        if (def.section_table_name === 'fx_aph_nptp' && def.field_column_name === 'state') {

          return {
            coding: Object.fromEntries(this.dict.states.map(state => [state, state])),
            section_slug: 'state',
            section_title: 'State',
            description: '',
            label: 'state',
            name: 'State',
            notes: '',
            type: 'varchar',
          };


        }


        return {
          coding: def.field_column_type === 'bit' ? { 0: 'No', 1: 'Yes' } : Object.fromEntries(JSON.parse(def.field_options).map(opt => [opt.value, opt.label])),
          section_slug: stringToSlug(def.section_title),
          section_title: def.section_title,
          description: def.field_config_hint,
          label: def.field_title,
          name: def.field_config_extended_label,
          notes: def.field_config_help_text,
          type: def.field_column_type,
        };
      });
    },

    /** Query as object, ignoring fields with no values to query */
    queryObj() {
      return Object.fromEntries(
        Object.entries(this.query)
          .filter(([key, value]) => Array.isArray(value) && value.length));

    },
    queryToString() {
      return JSON.stringify(this.queryObj);
    },
    queryToUrlParam() {
      let base64encoded = btoa(this.queryToString);
      return encodeURIComponent(base64encoded);
    },

    columnsToURLParam() {
      let data = JSON.stringify(this.userFields);
      return encodeURIComponent(btoa(data));
    },

    searchURL() {
      let url = new URL(window.location);
      url.hash = '';
      url.searchParams.set('query', this.queryToUrlParam);
      url.searchParams.set('columns', this.columnsToURLParam);
      return url.toString();
    },

    resultsURL() {
      let url = new URL(window.location);
      url.hash = '';
      url.pathname = '/vi-eligibility-criteria/results';
      url.searchParams.set('query', this.queryToUrlParam);
      url.searchParams.set('columns', this.columnsToURLParam);
      return url.toString();
    },


    groupedFields() {
      return simpleGroupBy(this.fieldsForDict, "section_slug");
    },
    groups() {
      return simpleGroupBy(this.fieldsForDict, "section_slug", 'None', (def) => def.label);
    },

    glabels() {
      return Object.fromEntries(Object.keys(this.groupedFields).map(key => [key, this.groupedFields[key][0].section_title]));
    },

    resultsCount() {

      let results = this.data.filter(record => {

        let match = true;

        Object.keys(this.queryObj).forEach(key => {
          let field = this.fieldsForDict.find(field => field.label === key);

          let hasOpts = Object.keys(field.coding).length > 0;

          if (hasOpts || field.type === 'bit') {
            match = match && this.queryObj[key].includes(`${record[key]}`);
          } else {
            if (field.type === 'integer') {
              match = match && this.queryObj[key].includes(record[key]);
            } else {
              //partial string match on text field
              match = match && record[key].toLowerCase().includes(record[key].toLowerCase().trim());
            }
          }
        });
        return match;
      });

      return results;
    }


  },
  watch: {
    currentField() {
      if (!this.query.hasOwnProperty(this.currentField)) {
        this.query[this.currentField] = [];
      }
    },
    searchURL() {
      history.replaceState(null, '', this.searchURL);
    },
  }
}
</script>

<style>
.row-scroll {
  max-height: 300px;
  overflow-y: auto;
}
</style>